{
  "titles": {
    "tasks": "Taken"
  },
  "messages": {
    "emptyStateTitle": "Geen taken",
    "emptyStateDescription": "Op dit moment zijn er geen taken. Zodra er een taak beschikbaar is, wordt deze hier automatisch weergegeven."
  },
  "taskTitles": {
    "FundingContractReviewDeviationProposal-interestRate": "Afwijkende rente aangevraagd",
    "FundingContractReviewDeviationProposal-durationInMonths": "Afwijkende looptijd aangevraagd"
  },
  "actions": {
  }
}
